import React from 'react';
import styled from 'styled-components';
import { ReactComponent as LotteryFailedSVG } from 'assets/images/lucky-draw/lottery-failed.svg';

const ErrorDialogContainer = styled.div`
    text-align: center;
    color: #fff;
    line-height: 1.6;
    padding: 20px 0;
    width: 350px;
`;

const ErrorDialogIconWrapper = styled.div`
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ErrorDialogXIcon = styled.div`
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        width: 100%;
        height: 100%;
    }
`;

const ErrorDialogText = styled.p`
    margin-bottom: 12px;
    font-size: 14px;
`;

const ErrorDialogLastText = styled.p`
    font-size: 14px;
`;

const LuckyDrawErrorDialog: React.FC = () => {
    return (
        <ErrorDialogContainer>
            <ErrorDialogIconWrapper>
                <ErrorDialogXIcon>
                    <LotteryFailedSVG />
                </ErrorDialogXIcon>
            </ErrorDialogIconWrapper>
            <ErrorDialogText>Sorry, your draw attempt failed due to a network issue.</ErrorDialogText>
            <ErrorDialogText>Any Points deducted will be refunded to your EVM address later.</ErrorDialogText>
            <ErrorDialogLastText>
                The BTC gas spent cannot be refunded. Please increase your gas limit and try again next time.
            </ErrorDialogLastText>
        </ErrorDialogContainer>
    );
};

export default LuckyDrawErrorDialog;
